import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mainWebsiteUrl } from '@/mocks/categories';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative flex min-h-[620px] w-full items-center justify-center overflow-hidden md:min-h-[720px]">
      <img
        src="https://readdy.ai/api/search-image?query=Premium%20streetwear%20flat%20lay%20with%20sneakers%20hoodie%20cap%20and%20accessories%20arranged%20on%20a%20warm%20cream%20background%20soft%20natural%20light%20editorial%20product%20photography%20muted%20sage%20green%20and%20neutral%20tones%20minimal%20aesthetic%20high%20detail&width=1600&height=900&seq=usfans-hero-02&orientation=landscape"
        alt="USFans Spreadsheet resource hub"
        title="USFans Spreadsheet resource hub"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60" />

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-24 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-xs font-semibold tracking-widest text-white backdrop-blur-sm">
          <span className="w-3 h-3 flex items-center justify-center">
            <i className="ri-sparkling-2-line" />
          </span>
          {t('hero_eyebrow')}
        </span>

        <h1 className="mt-6 font-heading text-3xl leading-tight text-white md:text-5xl">{t('hero_h1')}</h1>

        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white/85 md:text-lg">
          {t('hero_desc')}
        </p>

        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href={mainWebsiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-primary-500 px-7 py-3.5 text-sm font-semibold text-white transition-all hover:bg-primary-600 sm:w-auto whitespace-nowrap cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-grid-line" />
            </span>
            {t('hero_cta_main')}
          </a>
          <a
            href={mainWebsiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-accent-500 px-7 py-3.5 text-sm font-semibold text-white transition-all hover:bg-accent-600 sm:w-auto whitespace-nowrap cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shopping-bag-line" />
            </span>
            {t('hero_cta_buy')}
          </a>
          <Link
            to="/article/usfans-spreadsheet-guide"
            className="inline-flex w-full items-center justify-center gap-2 rounded-full border border-white/40 bg-white/10 px-7 py-3.5 text-sm font-semibold text-white transition-all hover:bg-white/20 sm:w-auto whitespace-nowrap cursor-pointer"
          >
            {t('hero_cta_guide')}
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        </div>

        <p className="mt-8 text-xs font-medium tracking-wide text-white/70">{t('hero_trust')}</p>
      </div>
    </section>
  );
}